export const VIEW_TYPES = Object.freeze({
  DAY: "day",
  WEEK: "week",
  MONTH: "month",
  TIMELINE: "timeline",
  RESOURCE: "resource",
  MAP: "map",
  LIST: "list",
  EMPLOYEE: "employee",
  DISPATCH: "dispatch",
});

export const TIME_FORMATS = {
  HOUR_12: "hh:mm a",
  HOUR_24: "HH:mm",
  DATE: "MMM DD, YYYY",
};

export const DEFAULT_TIME_SLOT_DURATION = 30; // minutes

export const EVENT_CELL_WIDTH = 100; // Default width for an event cell (e.g., 1 hour)
export const EVENT_CELL_HEIGHT = 80; // Default height for an event cell

export const DEFAULT_TIME_GRANULARITY_MINUTES = 30;

export const EVENT_TYPE_COLORS = {
  trucking: "blue",
  hvac: "green",
  plumbing: "orange",
  electrical: "purple",
  general: "gray", // Default for general or unspecified
};

export const EVENT_PRIORITY_COLORS = {
  high: "red",
  urgent: "red", // Added urgent, maps to red
  medium: "yellow",
  low: "green",
};

export const EVENT_STATUS_COLORS = {
  scheduled: "blue",
  in_progress: "orange", // Match In Progress in spec
  delayed: "orange", // Map delayed to orange as well
  completed: "green",
  cancelled: "gray",
};
